import axios from "axios";

export default async function getDocument(projectName, formName, documentId) {
    const res = await axios.get(`/project/${projectName}/${formName}/Document/${documentId}`)
    return res;
}